import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModal = styled.div`
  position: absolute;
  width: 80vw;
  max-width: 1064px;
  height: 500px;
  box-shadow: 0px 4px 4px ${({ theme }) => theme.shadows.strong};
  border-radius: 8px;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
`;

export const TextModal = styled.div`
  margin: 1em 2em;
  overflow-y: auto;
  .MuiToolbar-regular {
    min-height: 0px;
  }
`;

export const PrincipalTitle = styled.p`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.primary.purple};
`;

export const ContentRowData = styled.p`
  overflow: hidden;
  white-space: nowrap;
  width: 163px;
  text-overflow: ellipsis;
`;
